/**
 * Notify subscriptions
 * 
 * @module services/NotifySubscriptionService
 */
var service = {
    /**
     * Handle an inbound request.
     * 
     * @param {InternalSession} internal - The internal session instance
     * @param {SubscriptionNotification} notification - The inbound notification
     * @param {Function} callback - The service reference callback 
     */
    onRequest : function(internal, request, callback) {
        callback.respond();

        internal.getRouting().subscribe(request.info);
    }
};

module.exports = service;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/client/services/notify-subscription-service.js
// module id = 1002
// module chunks = 0